import { Paragraph } from './paragraph';

export class Note {
	public title: string;
	public date: string;
	public author: string;
	public context: string;
	public image: string;
	public body: [Paragraph];

	constructor(private atitle: string, 
		private adate: string,
		private aauthor: string,
		private acontext: string,
		private aimage: string,
		private abody: [Paragraph]){

		this.title = atitle;
		this.date = adate;
		this.author = aauthor;
		this.context = acontext;
		this.image = aimage;
		this.body = abody;
	}


}
